import {
    RESET_ACTIVITIES_HISTORY,
    SET_ACTIVITIES_REVIEW_FILTER,
    SET_TODO_ACTIVITIES
} from "@data/constants/activitiesConstants";
import {messengerConstants} from "@data/constants/messengerConstants";
import {studentsConstants} from "@data/constants/studentsConstants";
import {samConstants} from "@data/constants/samConstants";

export function resetActivitiesHistory(studentId) {
    return {type: RESET_ACTIVITIES_HISTORY, studentId: studentId}
}

export function incrementTutorMessengerNotReadCount() {
    return {type: messengerConstants.INCREMENT_TUTOR_MESSENGER_NOT_READ_COUNT}
}

export function incrementStudentMessengerNotReadCount(studentId) {
    return {type: messengerConstants.INCREMENT_STUDENT_MESSENGER_NOT_READ_COUNT, studentId: studentId}
}

export function setActivitiesReviewFilter(filter) {
    return {type: SET_ACTIVITIES_REVIEW_FILTER, filter: filter}
}

export function setTodoActivities(todoActivities) {
    return {type: SET_TODO_ACTIVITIES, todoActivities: todoActivities}
}

export function startAvatarGeneration() {
    return {type: studentsConstants.START_AVATAR_GENERATION}
}

export function stopAvatarGeneration() {
    return {type: studentsConstants.STOP_AVATAR_GENERATION}
}

// --- Sam Lot B (session immersive) ---

export function resetSamConversation(activityId) {
    return {type: samConstants.RESET_SAM_CONVERSATION, activityId}
}

// Push a Sam-authored bubble that didn't come from the conversation
// endpoint (e.g. the photo check's feedback, a proactive hello).
// `origin` distingue une relance d'ouverture ("proactive") d'un vrai tour de
// parole. La feuille en a besoin : son état d'accueil ne doit se déclencher
// que si Sam n'a encore rien dit d'AUTRE qu'un bonjour — sans ça, une réponse
// conservée en cache se retrouvait promue en accroche de bienvenue.
export function injectSamBubble(activityId, content, mood = null, origin = null) {
    return {
        type: samConstants.INJECT_SAM_BUBBLE,
        activityId,
        content,
        mood,
        origin,
    }
}

// Echo the photo the student just took, côté élève, dès le déclenchement
// de l'envoi. L'URI est locale (data URL sur web, file:// sur natif) : la
// bulle apparaît donc même quand le quali échoue ensuite — l'élève voit
// que sa photo est bien partie, ce qu'aucun texte ne peut prouver.
export function injectStudentScan(activityId, imageUri) {
    return {
        type: samConstants.INJECT_STUDENT_SCAN,
        activityId,
        imageUri,
    }
}

// Record that a proactive bubble has been consumed for this activity
// session, so the same teaser doesn't re-fire. `key` ∈ SAM_PROACTIVE_KEY.
export function ackSamProactiveBubble(activityId, key) {
    return {
        type: samConstants.ACK_SAM_PROACTIVE_BUBBLE,
        activityId,
        key,
    }
}

// Retire du fil un message de l'élève resté sans réponse (Sam en panne), au moment où il est
// renvoyé : le renvoi le repose, une seule fois. Aucun appelant du legacy.
export function dropSamMessage(activityId, messageId) {
    return {
        type: samConstants.DROP_SAM_MESSAGE,
        activityId,
        messageId,
    }
}
